import $ from 'jquery';
import DDTemplates from 'dd-templates';

import Drupal from './Drupal';
import Header from './Header';
import Footer from './Footer';
import FixNavigation from './FixNavigation';
import Menu from './Menu';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import CalendarFeed from './CalendarFeed';

import Hero from './Hero';
import Banner from './Banner';
import StatsSlider from './StatsSlider';
import BackgroundImage from './BackgroundImage';
import TwitterSlider from './TwitterSlider';
import Placeholder from './Placeholder';
import SelectBox from './SelectBox';
import EmailBtn from './EmailBtn';
import Notify from './Notify';
import SpotlightSlider from './SpotlightSlider';

// Add the theme behaviors

Drupal.behavior((context) => {
  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Hero Badassness

  $('.hero.block', context).each((i, element) => {
    if (!element.hero) {
      element.hero = new Hero(element);
    }
  });

  // Banner Badassness

  $('.banner.block', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new Banner(element);
    }
  });

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.fixNavigation) {
      element.fixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu) {
      element.menu = new Menu(element);
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
      $(element).addClass('ready');
    }
  });

  // Smart Footer

  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Homepage Stats Slider

  $('.stats.block', context).each((i, element) => {
    if (!element.statsSlider) {
      element.statsSlider = new StatsSlider(element);
    }
  });

  // Homepage Spotlight

  $('.spotlight.block .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, { destSelector: '.node-image' });
    }
  });

  $('.spotlight.block', context).each((i, element) => {
    if (!element.spotlightSlider) {
      element.spotlightSlider = new SpotlightSlider(element);
    }
  });

  // Pods Background Image

  $('.pods .views-row, .home-pods .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, { isPseudo: true });
    }
  });

  // Placeholder Text

  $('.pods .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element);
    }
  });

  // Homepage Twitter Slider

  $('.twitter-feed.block', context).each((i, element) => {
    if (!element.twitterSlider) {
      element.twitterSlider = new TwitterSlider(element);
    }
  });

  // Homepage Find County

  $('.find-county.block', context).each((i, element) => {
    // Adds a background image using the image uploaded to the published post.
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
    // Creates a select box from all of the related links.
    if (!element.selectBox) {
      element.selectBox = new SelectBox(element);
    }
  });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Notifications

  $('.notifications', context).each((i, element) => {
    if (!element.notify && $(element).find('.node').length) {
      element.notify = new Notify(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Add an email link to the social share block

  $('.block-dd_social .item-list ul', context).each((i, element) => {
    if (!element.emailBtn) {
      element.emailBtn = new EmailBtn(element);
    }
  });


  $('body.front #block-block-1', context).each((i, element) => {
    if (element) {
      $(element).addClass('twitter-feed');
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});



// WEBPACK FOOTER //
// ./theme.js